import React, { Fragment } from "react";
import { translate } from "../Services/translation";
import constants from "../constants";
const style = {
  minHeight: "150px",
  resize: "none",
  padding: "9px",
  boxSizing: "border-box",
  fontSize: "15px",
};
const stylecancel = {
  "margin-left": "2%",
};
const styleerror = {
  "margin-left": "1%",
  color: "red",
};

const BulkInsertForm = ({
  productlist = "",
  errors = {},
  result = {},
  isclear = false,
  onDismiss,
  onChange,
  onSubmit,
}) => (
  <div>
    <h2>{translate("mypage.bulkinsert.bulkinserttitle")}</h2>

    <div className="row">
      <label className="form__label" htmlFor="productlist">
        {translate("mypage.bulkinsert.note")}
      </label>
    </div>
    <div className="row">
      <div className="columns small-8 medium-4">
        <textarea
          className="form__input"
          id="productlist"
          name="productlist"
          style={style}
          value={productlist || ""}
          onChange={(event) => onChange("productlist", event.target.value)}
        />
      </div>
    </div>

    {errors.general && (
      <div style={styleerror}>{translate("mypage.bulkinsert.invaliddata")} {" : "}{errors.general}</div>
    )}
    {!isclear && result.invalidArticleNumber && (
      <div className="columns small-12 medium-8" style={styleerror}>
        {translate("mypage.bulkinsert.invaliddata")} :{" "}
        {result.invalidArticleNumber}
      </div>
    )}

    {
      <button className="form__button" onClick={() => onSubmit(productlist)}>
        {translate("mypage.bulkinsert.addtocart")}
      </button>
    }
    {
      <button
        className="form__button"
        style={stylecancel}
        onClick={() => onDismiss()}
      >
        {translate("mypage.bulkinsert.cancel")}
      </button>
    }
  </div>
);

export default BulkInsertForm;
